module.exports = __webpack_public_path__ + "img/print.230262d4.svg";